import React from "react";

import classnames from "classnames";

import { Grid } from "Common/Grid";
import { Div } from "Common/HTML";

import makeBem from "Utils/makeBem";

const bem = makeBem("Footer");

const FooterLink = (props) => <a className={bem("Link")} {...props} />;

type Props = {};

const IframeFooter = (_props: Props) => (
  <div className={classnames(bem())}>
    <Grid componentClass="footer">
      <Div p={4} className={classnames(bem("FlexContainer"))}>
        <p className="text-muted">&copy; {new Date().getFullYear()} Ten 250 Corporation, dba SimplyInsured. Insurance products sold by Vivek Ajay Shah.</p>
        <div className={bem("LinkListContainer")}>
          <ul className={classnames(bem("LinkList"), "list-inline")}>
            <li className={bem("ListItem")}>
              <FooterLink href="https://get.simplyinsured.com/insurance-licenses">Insurance Licenses</FooterLink>
            </li>
            <li className={bem("ListItem")}>
              <FooterLink href="https://get.simplyinsured.com/terms-of-service">Terms of Use</FooterLink>
            </li>
            <li className={bem("ListItem")}>
              <FooterLink href="https://get.simplyinsured.com/privacy-policy">Privacy Policy</FooterLink>
            </li>
          </ul>
        </div>
      </Div>
    </Grid>
  </div>
);

export default IframeFooter;
